import Fullscreen from "@pathwright/ui/src/components/fullscreen/Fullscreen"
import { useObserveSizeContext } from "@pathwright/ui/src/components/observers/ObserveSizeContext"
import withReorderPathItems from "@pathwright/web/src/modules/path/graphql/withReorderPathItems"
import classnames from "classnames"
import { ConnectStores } from "lib/core/store"
import flowRight from "lodash/flowRight"
import { DESIGN, TEACH } from "path/constants"
import PropTypes from "prop-types"
import { useState } from "react"
import { Motion, spring } from "react-motion"
import DragDropPathItems from "../path/DragDropPathItems"
import PathGroupContainer from "../path/list/group/PathGroupContainer"
import "./Lesson.css"
import LessonNav from "./LessonNav"

const LessonAnimator = ({ children, animate }) => {
  const transition = { stiffness: 80, damping: 20 }
  const configStyle = { y: spring(0, transition) }

  return animate ? (
    <Motion defaultStyle={{ y: 200 }} style={configStyle}>
      {(interpolatingStyle) => {
        const { y } = interpolatingStyle
        return (
          <div
            className="Lesson__transition-container"
            style={{ transform: `translate3d(0,${y}px,0)` }}
          >
            {children}
          </div>
        )
      }}
    </Motion>
  ) : (
    children
  )
}

const Lesson = ({ group, className, cohortId }, { mode }) => {
  const [collapsed, setCollapsed] = useState(true)
  const { getRectValue } = useObserveSizeContext()

  const toggleGroupSteps = () => setCollapsed(!collapsed)

  if (!group) return null

  return (
    <>
      <Fullscreen
        offset={{
          top: getRectValue("alert.height"),
          right: getRectValue("cardstack.width")
        }}
        themePortalElementID="fullscreen-theme-portal"
      >
        <div className={classnames("Lesson Lesson--detail", className)}>
          <LessonNav />
          <div className="Lesson__container">
            <LessonAnimator animate={mode < TEACH}>
              {mode === DESIGN ? (
                <DragDropPathItems items={[group]}>
                  <PathGroupContainer
                    item={group}
                    isInactive={false}
                    expanded
                    toggleGroup={toggleGroupSteps}
                    standaloneLesson
                  />
                </DragDropPathItems>
              ) : (
                <PathGroupContainer
                  item={group}
                  isInactive={false}
                  expanded={mode >= TEACH || !collapsed}
                  toggleGroup={toggleGroupSteps}
                  standaloneLesson
                />
              )}
            </LessonAnimator>
          </div>
        </div>
      </Fullscreen>
    </>
  )
}

Lesson.displayName = "Lesson"

Lesson.contextTypes = { mode: PropTypes.number }

const mapStateToProps = function (state, ownProps) {
  const {
    selected_group: group,
    mode,
    path,
    next_group
  } = state.pathStore.state
  const props = _.assign(
    {},
    {
      group
    },
    ownProps
  )
  return props
}

const stores = [{ store: "path", watch: ["selected_group", "path", "items"] }]

export default flowRight(withReorderPathItems)(
  ConnectStores(Lesson, stores, {}, mapStateToProps)
)
